import { Box, Theme, Typography, List, ListItem, ListItemText } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FC, useEffect, useState } from 'react';
import { Loader } from '../../../components';
import { INeighborhoodPunchlistUser } from '../../../models';
import { getNeighborhoodPunchlistUsers } from '../../../fetch';
import { dateSortDesc, formatShortFriendlyDateWithTime } from '../../../helpers';
import { useParams } from 'react-router-dom';

interface IPunchlistUsersList {}

export const PunchlistUsersList: FC<IPunchlistUsersList> = () => {
  const classes = useStyles();
  const { neighborhoodId }: { neighborhoodId: string } = useParams();

  const [isLoadingUsers, setLoadingUsers] = useState<boolean>(true);
  const [punchlistUsers, setPunchlistUsers] = useState<INeighborhoodPunchlistUser[]>([]);

  const fetchPunchlistUsers = async () => {
    try {
      setLoadingUsers(true);
      const res = await getNeighborhoodPunchlistUsers(neighborhoodId);
      const sortByLastActivity = dateSortDesc(res, 'lastActivity');
      setPunchlistUsers(sortByLastActivity);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingUsers(false);
    }
  };

  useEffect(() => {
    fetchPunchlistUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <List
        component="nav"
        aria-labelledby="assigned-people-list-header"
        subheader={
          <Typography color="primary" variant="h5" id="assigned-people-list-header" sx={{ marginBottom: theme => theme.spacing(0.5) }}>
            Assigned People
          </Typography>
        }
      >
        {!isLoadingUsers && (punchlistUsers?.length === 0 || !punchlistUsers) && (
          <ListItem dense disablePadding>
            <Typography>There are no users to display.</Typography>
          </ListItem>
        )}
        {!isLoadingUsers && punchlistUsers && punchlistUsers?.length > 0 && (
          <>
            {punchlistUsers.map((user, userIndex) => {
              return (
                <ListItem dense disablePadding key={userIndex} className={classes.listItem}>
                  <ListItemText
                    primary={user.username}
                    secondary={`Last activity: ${formatShortFriendlyDateWithTime(user.lastActivity)}`}
                    primaryTypographyProps={{ component: 'h6', variant: 'h6', className: classes.subHeader }}
                  />
                </ListItem>
              );
            })}
          </>
        )}
      </List>
      {isLoadingUsers && (
        <Box>
          <Loader position="left" type="inline" />
        </Box>
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  subHeader: {
    lineHeight: 1.25
  },
  listItem: { paddingTop: theme.spacing(0.25), paddingBottom: theme.spacing(0.25) }
}));
